// router
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES, ROUTES } from 'router/routes';

// components
import { AdminBacktestsPage } from '@karehero/llama/pwa/pages/AdminBacktestsPage/AdminBacktestsPage';

// store
import { useListBacktestsQuery } from 'store/api/evaluation';

export const AdminBacktests = () => {
  const navigate = useNavigate();
  const { data: backtests = [], isLoading, isError } = useListBacktestsQuery();

  return (
    <AdminBacktestsPage
      backtests={backtests}
      isLoading={isLoading}
      isError={isError}
      onNewBacktest={() => navigate(ROUTES.ADMIN_BACKTEST_NEW)}
      onOpenBacktest={(backtestID) =>
        navigate(DYNAMIC_ROUTES.ADMIN_BACKTEST(backtestID))
      }
    />
  );
};

export default AdminBacktests;
